import * as ReactBootstrap from 'react-bootstrap'
import { Button } from 'react-bootstrap'
import * as components from '../../../components'
import React from 'react'
import {TicketPrint, UploadContent} from "../../../api";
import AttachmentDelete from "./AttachmentDelete";
import Moment from "react-moment";

export type AttachmentProps={
    document:UploadContent
    ticket:TicketPrint
    onTicketUpdate:(ticket:TicketPrint)=>void
}

const Attachment = ({ document, ticket, onTicketUpdate }:AttachmentProps) => {
  // @ts-ignore
    const { description, gsx_module_type,
      s3_upload_get_path, upload_type ,
      gsx_upload_id,gsx_url,created_by_name } =
    document
  return (
    <ReactBootstrap.Row>
      <ReactBootstrap.Col xs={10}>
        <p>
          <strong>Description:</strong>
          {description}
          <br />
          <strong>Type:</strong>
          {upload_type}
          <br />
          <strong>GSX Upload Type:</strong>
          {gsx_module_type ? gsx_module_type : 'N/A'}
          <br />
             <strong>GSX Upload Id:</strong>
          {gsx_upload_id ? gsx_upload_id : 'N/A'}
          <br /><strong>GSX Upload URL:</strong>
          {gsx_url ? gsx_url : 'N/A'}
          <br />
            <strong>Added By:</strong>
          {created_by_name ? created_by_name : 'N/A'}
          <br />

            <strong>Added On:</strong>
                 <Moment format="DD-MM-YYYY" local>
       {document.created_at}
      </Moment>  <sub> <Moment fromNow>{document.created_at}</Moment>
        </sub>
        <br />
        </p>
      </ReactBootstrap.Col>
      <ReactBootstrap.Col
        style={{
          textAlign: 'right',
        }}
        xs="1"
      >
        <Button
          className="text-dark"
          target="_blank"
          href={s3_upload_get_path}
          variant="link"
        >
          {components.ICONS.DOWNLOAD}
        </Button>
      </ReactBootstrap.Col>

        <ReactBootstrap.Col xs="1">
          <ReactBootstrap.Dropdown>
            <ReactBootstrap.Dropdown.Toggle variant="dark" size="sm" />
            <ReactBootstrap.Dropdown.Menu>
              <AttachmentDelete document={document} onDelete={(document)=>onTicketUpdate(ticket)}/>
            </ReactBootstrap.Dropdown.Menu>
          </ReactBootstrap.Dropdown>
        </ReactBootstrap.Col>

    </ReactBootstrap.Row>
  )
}

export default Attachment
